<template>
    <div class="rel h:86 w:100% overflow:hidden">
        <div class="rel h:100% w:4096 left:50% translateX(-50%) top:0 overflow:hidden">
            <div class="abs h:100% top:0 left:50% w:4096 ml:-284">
                <div class="abs w:6 h:6 left:0 bottom:50% translateY(50%) rounded bg:#D4D4D4" :class="`ml:${item*32}`" v-for="(item) in 128"></div>
            </div>
        </div>
    </div>
</template>
